import Link from 'next/link';

type props = {
  href?: string;
  className?: string;
  onClick?: (argument: any) => void;
  children: React.ReactNode;
  target?: string;
};

export const PEILink = ({
  href = '',
  className = '',
  children,
  onClick,
  target = '_blank',
  
}: props) => {
  return (
    <Link prefetch={false} href={href} className={className} target={target} onClick={onClick}>
      {children}
    </Link>
  );
};
